<template>
  <div class="cookie-stay-pop" id="cookie-stay-pop" v-if="popShow">
    <div class="bg" id="bg"></div>
    <div class="card">
      <div class="header">
        <p class="title">{{ $t('GDriver_Compliance__uEcc') }}</p>
      </div>
      <div class="desc" v-html="cookieDesc()"></div>
      <div class="btns">
        <p class="btn yes dim-button dim-button-block dim-button-orange"  :class="[`${country}`,country=='BR'?'dim-button-yellow':'dim-button-orange']" id="yes-btn" @click="closePop">
          {{ $t("GDriver_Compliance__kBzY") }}
        </p>
        <p class="btn no dim-button dim-button-block dim-button-default" id="no-btn" @click="closeCookie">
          {{ $t("GDriver_Compliance__pDWp") }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { BRAND_NAME_MAP } from '../../tools/constant';
export default {
  data() {
    return {
      popShow: false,
    };
  },
  computed: {
    country() {
      const params = new URLSearchParams(location.search);
      return params.get("location_country");
    },
    pic_desc() {
      return this.formItem.pic_desc || {};
    },
  },
  // mounted() {
  //   console.log(11111);
  // },
  methods: {
    cookieDesc() {
      const BRAND_NAME_MAP = {
        'global': this.$t('GDriver_Name_DiDi_Gsik'),
        'BR': this.$t('GDriver_Name_99_mpNh')
      }
      const brand_name = BRAND_NAME_MAP[BRAND_NAME_MAP] || BRAND_NAME_MAP['global']
      return this.$t('GDriver_Compliance__VcFX')
              .replace(/\{\{Brand_name\}\}/, brand_name)
              .replace(/\{\{\{Cookie_Notice\}\}\}/, `<a href='https://privacycenter.didiglobal.com/welcome' target="_blank">${this.$t('GDriver_Compliance__iMRa')}</a>`)
    },
    closePop() {
      this.popShow = false;
      window.localStorage && window.localStorage.setItem('hasSelectedCookieSet',1)
      window.track();
    },
    closeCookie() {
      this.popShow = false;
      window.localStorage && window.localStorage.setItem('hasSelectedCookieSet',0)
    },
  },
};
</script>
<style lang="scss" scoped>
.cookie-stay-pop {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;
  /* transform:  translateY(100%); */
  height: 100%;
  width: 100%;
  .bg {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: hidden;
    opacity: 0.6;
    background: #0f1928;
  }
  .card {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    // padding-bottom: 1.7rem;
    box-sizing: border-box;
    border-radius: 0.36rem 0.36rem 0 0;
    background: #ffffff;
    .header {
      min-height: 1.2rem;
    }
    .pop-close {
      position: absolute;
      right: 0.36rem;
      top: 0.36rem;
      width: 0.48rem;
    }
    .title {
      padding: 0.33rem;
      font-size: 0.40rem;
      font-weight: bold;
      color: #333333;
    }
    .desc {
      padding: 0.05rem 0.33rem 0.33rem 0.33rem;
      font-size: 0.32rem;
      color: #666666;
      letter-spacing: 0;
      line-height: 0.38rem;
      ::v-deep a {
        font-size: 0.32rem;
        font-weight: 500;
        color: #ff7226;
      }
    }
    .btns {
      // position: absolute;
      // bottom: 0;
      width: 100%;
      box-sizing: border-box;
      padding: 0.32rem;
      font-size: 0.36rem;
      color: #FFFFFF;
      .btn {
        text-align: center;
      }
      .yes {
        height: 1.08rem;
        line-height: 1.08rem;
        // font-weight: 700;
        // background: #FF7226;
        // border-radius: 0.12rem;
      }
      .no {
        margin-top: 0.32rem;
        // font-size: 0.32rem;
        // font-weight: 500;
        // color: #666;
      }
    }
  }
}
</style>

